/**
 * Private modules
 */
const {
  createQueryComponent,
  enUs,
  objectId,
  systemId,
  thTh,
} = require('../.private').components;

/**
 * Scopes
 */
const {
  DEFAULT,
  SYSTEM_TRANSLATIONS_GLOBAL,
  SYSTEM_TRANSLATIONS_INPUT,
} = require('../../scopes');

module.exports = {
  getSystemTranslations: {
    properties: {
      params: {
        properties: {
          systemId,
        },
        required: ['systemId'],
        type: 'object',
      },
      query: createQueryComponent([
        DEFAULT,
        SYSTEM_TRANSLATIONS_GLOBAL,
        SYSTEM_TRANSLATIONS_INPUT,
      ]),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  updateSystemTranslations: {
    properties: {
      body: {
        properties: {
          elements: {
            items: {
              properties: {
                enUs,
                objectId,
                thTh,
              },
              required: [
                'enUs',
                'objectId',
                'thTh',
              ],
              type: 'object',
            },
            minItems: 1,
            type: 'array',
            uniqueItems: true,
          },
        },
        required: ['elements'],
        type: 'object',
      },
      params: {
        properties: {
          systemId,
        },
        required: ['systemId'],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
};
